import React from 'react'
import { QueryStatus } from 'react-query'
import { SelectBox, SelectBoxProps } from 'components'
import { CustomAxiosError } from 'utils/api'

export type SelectQueryProps = {
  selectedQueryTitle: string
  setSelectedQueryTitle: (queryTitle: string) => void
  options: SelectBoxProps['options']
  status: QueryStatus
  error?: CustomAxiosError | null
  label?: string
}

export const SelectQuery = (props: SelectQueryProps) => {
  const { selectedQueryTitle, setSelectedQueryTitle, options, status, error, label } = props

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (setValidation: boolean = false) => {
    if (status === 'error') {
      return error?.errorMessage ?? 'Network Error!'
    }
    if (!selectedQueryTitle) {
      if (fieldError) return true
      else if (setValidation) setFieldError('triggered')
    }
    return ''
  }
  const getErrorText = () => {
    const value = validateField()
    if (typeof value === 'string') return value
    return ''
  }

  const sortedOptions = [...options].sort((a, b) => (a.text > b.text ? 1 : -1))

  const handleQueryChange = (selectedQuery: string) => {
    setSelectedQueryTitle(selectedQuery)
  }

  return (
    <div className="w-full mr-10 mb-10 sm:w-64">
      <SelectBox
        label={label ?? 'Select a Saved Query *'}
        placeholder="Select query"
        id="select-query"
        value={selectedQueryTitle}
        onChange={handleQueryChange}
        isLoading={status === 'loading'}
        options={sortedOptions}
        onBlur={() => validateField(true)}
        error={!!validateField()}
        helperText={getErrorText()}
      />
    </div>
  )
}
